import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import * as rest from '../../services'
import { Slider, ICONS } from '../../components'
import { reset } from 'redux-form'
import { useDispatch } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import ComponentIssueForm from './forms/ComponentIssueForm'

const reproducibilityOptions = [
  { code: 'A', description: 'Not Applicable' },
  {
    code: 'B',
    description: 'Continuous',
  },
  {
    code: 'C',
    description: 'Intermittent',
  },
  {
    code: 'D',
    description: 'Fails After Warm Up',
  },
  {
    code: 'E',
    description: 'Environmental',
  },
  {
    code: 'F',
    description: 'Configuration: Peripheral',
  },
  {
    code: 'G',
    description: 'Damaged',
  },
  {
    code: 'H',
    description: 'Screening Request',
  },
]
export const ComptiaDelete = ({ ticket, comptia, onDelete }) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.ComponentIssueService(comptia.url)
      .makeDeleteRequest()
      .then((response) => {
        const device  = {...ticket.device,component_issues:[...ticket.device.component_issues.filter(x=>response.url!=x.url)]}
        onDelete({...ticket,device:device})
        dispatch(showSuccessToast('Success', 'Comptia Deleted successfully'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to delete this Comptia?"
        confirmText="Confirm delete Comptia"
        confirmBSStyle="danger"
        title="Confirm delete Comptia"
      >
        <ReactBootstrap.Button
          disabled={comptia.is_deleted}
          variant="danger"
          eventKey="1"
          className="ml-1"
        >
          {components.ICONS.DELETE}
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

export const ComptiaInfo = ({ ticket, comptia, onTicketUpdate }) => {
  return (
    <div>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">
              <p style={{ wordWrap: 'break-word' }} className="text-justify">
                <strong>Component: </strong>{' '}
                <span>
                  {comptia.component_description}({comptia.component_code})
                </span>
                <br />
                <strong>Issue: </strong>{' '}
                <span>
                  {comptia.issue_description}({comptia.issue_code})
                </span>
                <br />
                <strong>Reproducibility: </strong>{' '}
                <span>
                  {
                    reproducibilityOptions.filter(
                      (x) => x.code === comptia.reproducibility
                    )[0].description
                  }
                  ({comptia.reproducibility})
                </span>
              </p>
            </ReactBootstrap.Col>
            <ReactBootstrap.Col className=" text-end" xs="6">
              <ComptiaDelete ticket={ticket} comptia={comptia} onDelete={onTicketUpdate} />
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}

export const TicketComponentIssues = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const { device } = ticket
  const [componentIssuesOptions, setComponentIssuesOptions] = useState(null)
  const createComptiaInfo = (values) => {
    const payload = {
      ...values,
      device: ticket.device.url,
      component_description: componentIssuesOptions.filter(
        (x) => x.componentCode === values.component_code
      )[0].componentDescription,
      issue_description: componentIssuesOptions
        .filter((x) => x.componentCode === values.component_code)[0]
        .issues.filter((x) => x.code === values.issue_code)[0].description,
      priority: device?.component_issues?.length + 1,
    }

    const promise = new rest.ComponentIssueService().makePostRequest(payload)
    promise
      .then((response) => {
        dispatch(reset('ComponentIssueForm'))
        const device  = {...ticket.device,component_issues:[response,...ticket.device.component_issues]}
        onTicketUpdate({...ticket,device:device})
        dispatch(
          showSuccessToast('Success', 'Component Issue Details have be saved.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error Saving Device Info',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  const getComponentIssueOptions = (identifier) => {
    const data = {
      data: {
        device: {
          id: identifier,
        },
      },
    }
    new rest.GSXService()
      .repair_product_componentissue(data)
      .then((response) => {
        setComponentIssuesOptions(response.componentIssues)
      })
      .catch((errors) => {
        console.log(errors)
        setComponentIssuesOptions(null)
      })
  }
  return (
    <div className="mt-5">
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">Comptia Information</ReactBootstrap.Col>
            <ReactBootstrap.Col xs="6">
              <div className="text-end">
                <Slider
                  title={ICONS.PLUS}
                  onAfterOpen={() =>
                    getComponentIssueOptions(device.serial_number)
                  }
                  header={
                    <>
                      <span>{ICONS.PLUS}</span>
                      <span className="pl-3">Add Comptia Info</span>
                    </>
                  }
                >
                  {componentIssuesOptions ? (
                    <ComponentIssueForm
                      reproducibilityOptions={reproducibilityOptions}
                      componentIssuesOptions={componentIssuesOptions}
                      onSubmit={createComptiaInfo}
                    />
                  ) : (
                    <components.Loading />
                  )}
                </Slider>
              </div>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body>
          {device.component_issues && device?.component_issues?.length ? (
            <components.ItemList
              itemRenderer={(index, key) => {
                return (
                  <div key={device.component_issues[index].url}>
                    <ComptiaInfo
                      ticket={ticket}
                      comptia={device.component_issues[index]}
                      onTicketUpdate={onTicketUpdate}
                    />
                  </div>
                )
              }}
              length={device.component_issues.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No Comptia Info found.
            </ReactBootstrap.Alert>
          )}
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </div>
  )
}
